module.exports = __webpack_public_path__ + "img/Avatar_people@2x.17f06001.png";